import { Button } from "./ToolbarButton"
import { Delete_Logo } from "./Icons"
import { Transforms } from "slate"
import { useSlateStatic, useSelected, useFocused, ReactEditor } from "slate-react"
export const Image = ({ attributes, children, element }) => {
  const editor = useSlateStatic()
  const path = ReactEditor.findPath(editor, element)

  const selected = useSelected()
  const focused = useFocused()
  return (
    <div {...attributes}>
      {children}
      <div
        contentEditable={false}
        className="relative"
      >
        <img
          src={element.url}
          alt="img"
          className={`block max-w-full max-h-[20em] ${selected && focused ? 'ring-2 ring-gray-900' : ''}`}
        />
        <Button
          active
          onClick={() => Transforms.removeNodes(editor, { at: path })}
          className={`${selected ? 'inline' : 'hidden'} absolute top-[.5em] left-[.5em] `}
        >
          <Delete_Logo/>
        </Button>
      </div>
    </div>
  )
}
const Element = ({ attributes, children, element }) => {
    const style = { textAlign: element.align }
    switch (element.type) {
      case 'block-quote':
        return (
          <blockquote style={style} {...attributes}>
            {children}
          </blockquote>
        )
      case 'bulleted-list':
        return (
          <ul className="!list-disc list-inside" style={style} {...attributes}>
            {children}
          </ul>
        )
      case 'heading-one':
        return (
          <h2>
            {children}
          </h2>
        )
      case 'heading-two':
        return (
          <h2 style={style} {...attributes}>
            {children}
          </h2>
        )
      case 'list-item':
        return (
          <li className="list-item" style={style} {...attributes}>
            {children}
          </li>
        )
      case 'numbered-list':
        return (
          <ol className="!list-decimal list-inside" style={style} {...attributes}>
            {children}
          </ol>
        )
        case 'image':
          // eslint-disable-next-line jsx-a11y/alt-text, react/no-children-prop
          return (<Image attributes={attributes} children={children} element={element} />)
      default:
        return (
          <p style={style} {...attributes}>
            {children}
          </p>
        )
    }
  }

  export default Element